module.exports = __webpack_public_path__ + "img/color.f814d02b.png";